// store.js
import Vue from 'vue';
import Vuex from 'vuex';
import {Message} from 'element-ui';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    wxChatUser: {},
    messageInstance: null
  },
  mutations: {
    setWeChatUser(state, value) {
        state.wxChatUser = value;
      },
    handleMessageInstance(state, paylod) {
      return new Promise((resolve, reject) => {

        //控制 某些重要提示，优先显示，不需要直接注释了就行
        if(state.messageInstance && state.messageInstance.message == 'xxx') return resolve(paylod)


        if(state.messageInstance) {state.messageInstance.close()}//如果实例存在，手动关闭所有实例。

        state.messageInstance = Message(paylod) //赋值最新的实例
        resolve(state.messageInstance)
      })
    },
  },
  actions: {
    // 定义异步操作和业务逻辑
  },
  getters: {
    // 定义从状态中派生的计算属性
  }
});
